export const makeSeed = () => ({
  users: [{ id: 1, name: "Carlos", password: "1234", active: true }, { id: 2, name: "João", password: "1234", active: true }],
  suppliers: [
    { id: 1, name: "AgroCenter Brasil", category: "Insumos agrícolas", contact: "(64) 99123-4567", email: "contato@agrocenter.com" },
    { id: 2, name: "NutriRação Ltda", category: "Alimentação animal", contact: "(64) 99234-5678", email: "pedidos@nutriracao.com" },
    { id: 3, name: "Posto Agro Sul", category: "Combustível", contact: "(64) 99345-6789", email: "abastece@postoagro.com" },
  ],
  orders: [], animals: [], financial: [], employees: [], vet: [], stock: [], machinery: [],
});
